
import "@babel/polyfill";
import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';
import 'core-js/fn/number/is-nan';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { Provider } from 'react-redux';

import store, { history } from './store/';
import PrimaryLayout from './Layouts/PrimaryLayout';
import UnauthorizedLayout from './Layouts/UnauthorizedLayout';
import AuthorizedRoute from './AuthorizedRoute';
import ImplicitCallback from './containers/ImplicitCallback';

import './styles/main.css';


const CelaneseApp = (
	<Provider store={store}>
		<BrowserRouter history={history}>
			<Switch>
				<Route path="/login" component={UnauthorizedLayout} />
				<Route path="/authorization-code/callback" component={ImplicitCallback} />
                <Route path="/authorization-code/pkce-callback" component={ImplicitCallback} />
				<AuthorizedRoute path="/" component={PrimaryLayout} />
				<Redirect to="/404" />
			</Switch>
		</BrowserRouter>
	</Provider>
);

ReactDOM.render(
	CelaneseApp,
	document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js